export default __webpack_public_path__ + "static/media/queues.a7a0d3d8.svg";